import { render, staticRenderFns } from "./TermDependentsModal.vue?vue&type=template&id=0d8b8d2e&scoped=true&v-if=widgetReady&"
import script from "./TermDependentsModal.vue?vue&type=script&lang=js&"
export * from "./TermDependentsModal.vue?vue&type=script&lang=js&"
import style0 from "./TermDependentsModal.vue?vue&type=style&index=0&id=0d8b8d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8b8d2e",
  null
  
)

component.options.__file = "TermDependentsModal.vue"
export default component.exports